import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CustomerComponents from '../../Pages/CustomerPage/CustomerComponents';
import ChangePwd from '../../Pages/Login/Pages/ChangePwd';
import { MOBILE_REPORT_PATH, MOBILE_MENU_PATH } from './mobileTabs';
import { REPORT_SECTIONS } from './screens/reportViews/reportConfig';
import MobileMenu from './MobileMenu';
import MobilePriorities from './screens/MobilePriorities';
import MobileContacts from './screens/MobileContacts';
import MobileAgenda from './screens/MobileAgenda';
import MobileReport from './screens/MobileReport';
import useMobileNavigation from './useMobileNavigation';

/**
 * MobileRouter — routes the mobile allow-list to mobile screens and mounts the
 * shared customer overlay (opened via selectedCustomerIdAtom, e.g. tapping a
 * priority/contact). See MOBILE_PLAN.md §C.
 */
const MobileRouter = function MobileRouter({
  priorities = [],
  prioritiesLoading = false,
  userRoles = [],
  onLogout = () => {},
  version = null,
}) {
  // Every page is served at the address the desktop serves it at, and only when the user holds it,
  // so changing width keeps the URL. See useMobileNavigation.
  const { paths, tabs, lists, reports } = useMobileNavigation();

  // An address this router does not serve is a desktop-only page, like the kanban. It goes back to
  // the last mobile section when there is one: the Report tab for a report, the page itself when it
  // is one this router serves; otherwise to the first area the user has.
  const currentSection = sessionStorage.getItem('currentSection');
  const servesSection =
    currentSection === 'PRIORITIES' ||
    currentSection === 'APPOINTMENT' ||
    lists.some(({ key }) => key === currentSection);
  const fallbackPath =
    (REPORT_SECTIONS.includes(currentSection) &&
      reports.length > 0 &&
      MOBILE_REPORT_PATH) ||
    (servesSection && paths[currentSection]) ||
    tabs[0]?.path ||
    MOBILE_MENU_PATH;

  return (
    <>
      <Routes>
        {paths.PRIORITIES && (
          <Route
            path={paths.PRIORITIES}
            element={
              <MobilePriorities
                priorities={priorities}
                loading={prioritiesLoading}
              />
            }
          />
        )}
        {lists.map((list) => (
          <Route key={list.key} path={list.path} element={<MobileContacts />} />
        ))}
        {paths.APPOINTMENT && (
          <Route path={paths.APPOINTMENT} element={<MobileAgenda />} />
        )}
        {reports.length > 0 && (
          <Route path={MOBILE_REPORT_PATH} element={<MobileReport />} />
        )}
        <Route
          path={MOBILE_MENU_PATH}
          element={
            <MobileMenu
              onLogout={onLogout}
              version={version}
              userRoles={userRoles}
            />
          }
        />
        <Route path="/changePassword" element={<ChangePwd />} />
        <Route path="*" element={<Navigate to={fallbackPath} replace />} />
      </Routes>
      <CustomerComponents />
    </>
  );
};

export default MobileRouter;
